export interface Book {
  id: number;
  title: string;
  author: string;
  description?: string;
  cover?: string;
  format: string;
  viewCount: number;
  rating: number;
  uploadedAt: string;
}

export interface BookState {
  books: Book[];
  currentBook: Book | null;
  loading: boolean;
  error: string | null;
}

const initialState: BookState = {
  books: [],
  currentBook: null,
  loading: false,
  error: null,
};

const bookReducer = (state = initialState, action: any): BookState => {
  switch (action.type) {
    case 'FETCH_BOOKS_START':
      return { ...state, loading: true };
    case 'FETCH_BOOKS_SUCCESS':
      return { ...state, books: action.payload, loading: false };
    case 'FETCH_BOOKS_FAILURE':
      return { ...state, error: action.payload, loading: false };
    case 'FETCH_BOOK_DETAIL_SUCCESS':
      return { ...state, currentBook: action.payload, loading: false };
    default:
      return state;
  }
};

export default bookReducer;
